export default {
    template: /*html*/`
    <svg xmlns="http://www.w3.org/2000/svg" width="21.959" height="21.429" viewBox="0 0 21.959 21.429">
        <path id="Tracciato_104" data-name="Tracciato 104" d="M1309.626,311.984a8.615,8.615,0,1,0-8.616,8.613A8.614,8.614,0,0,0,1309.626,311.984Z" transform="translate(-1292.147 -303.121)" fill="none" stroke="#707070" stroke-miterlimit="10" stroke-width="0.5"/>
        <line id="Linea_13" data-name="Linea 13" x2="6.573" y2="6.573" transform="translate(15.209 14.68)" fill="none" stroke="#707070" stroke-miterlimit="10" stroke-width="0.5"/>
    </svg>
    `
}